<template>
  <h3 class="pb5">Rapport des suivis en retard par intervenant (CDX_0095)</h3>
  <CritereRechercheSuivis ref="critereRechercheSuivis"
                          :entiteDefault="entiteDefault" :siteDefault="siteDefault"/>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import CritereRechercheSuivis from "@/components/rapports/Rechercher/CritereRechercheSuivis.vue";
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "suiviRetardIntervenant",
  components: {CritereRechercheSuivis, ButtonBar},
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Suivis");
    this.isRechercheDataLoading = true;

    this.$store.dispatch("dossier/obtenirSiteEntiteAction")
        .then((res) => {
          this.entiteDefault = res.data.entite;
          this.siteDefault = res.data.site;

          this.$store.dispatch("dossier/rechercherDefaut48HeuresAction")
              .then((res) => {
                this.assignerResultat(res);
                this.isRechercheDataLoading = false;
              });
        });
  },

  data() {
    return {
      isRechercheDataLoading: false,
      entiteDefault: null,
      siteDefault: null,
    }
  },

  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },

  methods: {
    assignerResultat(res) {
      this.$root.$refs.messagesComp.messagesList = res.data.messages;
      this.$refs.critereRechercheSuivis.assignerListe(res.data.entiteDecision);
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      var criteresRapportVO = this.$refs.critereRechercheSuivis.getCritereRecherche();
      criteresRapportVO.titre = "suiviRetardIntervenant";
      criteresRapportVO.nomRapport = "suivi.RetardIntervenantSuiviGenerateurRapport_CDX_0095";
      this.$store.dispatch("rapports/obtenirRapportAction", criteresRapportVO)
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
}
</script>
